import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import {
  Button,
  Modal,
  ModalButtonProps,
  Input,
} from '@forma/forma-ui-kit';

import { IProductPropertiesItem } from 'interfaces/products.interface';
import { TVariableType } from 'interfaces/variables.interface';

import styles from './create-edit-column.module.css';

interface CreateEditColumnProps {
  open: boolean,
  onClose: (open: false) => void,
  data?: IProductPropertiesItem,
  onAdd?: (data: Omit<IProductPropertiesItem, 'id'>) => void,
  onEdit?: (data: IProductPropertiesItem) => void,
  onRemove?: (id: string) => void
}

const CreateEditColumn = ({ open, onClose, data, onAdd, onEdit }: CreateEditColumnProps) => {
  const { t } = useTranslation();
  // const [isRemoveOpen, setRemoveOpen] = useState<boolean>(false);
  const [name, setName] = useState<string>(data?.name ?? '');
  const [type, setType] = useState<TVariableType>(data?.type ?? 'string');

  useEffect(() => {
    setName(data?.name ?? '');
    setType(data?.type ?? 'string');
  }, [open, data]);

  const handleSubmit = () => {
    if (data) {
      if (onEdit) onEdit({ id: data.id, name, type });
    } else {
      if (onAdd) onAdd({ name, type });
    }
    onClose(false);
  };

  const types: { name: string, value: TVariableType }[] = [
    {
      name: t('properties.string'),
      value: 'string'
    },
    {
      name: t('properties.number'),
      value: 'decimal'
    },
    {
      name: t('properties.price'),
      value: 'money'
    },
  ];

  const buttons: ModalButtonProps[] = [
    {
      viewStyle: 'tertiary',
      children: t('uikit:cancel'),
    },
    {
      viewStyle: 'primary',
      children: t('uikit:save'),
      onClick: handleSubmit,
      disabled: name.length < 3 || !type
    }
  ];

  // if (data && onRemove) {
  //   buttons.push({
  //     viewStyle: 'secondary',
  //     children: t('uikit:delete'),
  //     onClick: () => setRemoveOpen(true),
  //   });
  // }

  return (
    <>
      <Modal
        width="100%"
        maxWidth="450px"
        open={open}
        onClose={onClose}
        title={data ? t('uikit:edit') : t('new_column')}
        buttonsClassName={styles.modalButtons}
        buttons={buttons}
      >
        <input type="hidden" autoFocus />
        <div className={styles.modal}>
          <Input
            name="column_name"
            viewStyle="secondary"
            placeholder={t('column_name')}
            onChange={e => setName(e.target.value)}
            value={name}
            className={styles.input}
            autoFocus
          />
          <div className={styles.label}>
            {t('column_type')}
          </div>
          <div className={styles.buttons}>
            {types.map(({ name, value }) => (
              <Button
                viewStyle="secondary"
                onClick={() => setType(value)}
                className={classNames(styles.button, value === type && styles.active)}
                key={value}
              >
                {name}
              </Button>
            ))}
          </div>
        </div>
      </Modal>
      {/* <RemoveModal
        open={isRemoveOpen}
        onClose={() => setRemoveOpen(false)}
        title={t('remove_column')}
        onRemove={() => !!(onRemove && data) && onRemove(data.id)}
      /> */}
    </>
  );
};

export default CreateEditColumn;
